// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3oqB7","list":"BalanceDue_list__3c321","listRow":"BalanceDue_listRow__3MSOu","total":"BalanceDue_total__FT0rH"};